import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import handleSubmit from "redux-form/lib/handleSubmit";

const DEFAULT_SELECTED_INDEX = 0;

class MultiSectionsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: DEFAULT_SELECTED_INDEX,
    };
  }

  makeSectionNavigationHandler = (i) => () =>
    this.props.disableNavigation
      ? this.props.revealErrors()
      : this.setState({ ...this.state, selectedIndex: i });

  renderSectionLink = (section, i) => {
    const classes = classNames({
      SectionLink: true,
      active: i === this.state.selectedIndex,
      "has-error": false,
    });
    return (
      <li key={i} onClick={this.makeSectionNavigationHandler(i)}>
        <a className={classes}>{section.sectionName}</a>
      </li>
    );
  };

  renderSelectedSection = () => {
    const sections = this.props.children;
    const index = this.state.selectedIndex;
    return sections[index].section;
  };

  render = () => {
    const { children, bodyClasses } = this.props;

    return (
      <div className="MultiSectionsModalBody">
        <div className="SideBar">
          <div className="sub-nav">
            <ul>{children.map(this.renderSectionLink)}</ul>
          </div>
        </div>
        <div className={bodyClasses}>
          <form onSubmit={handleSubmit}>{this.renderSelectedSection()}</form>
        </div>
      </div>
    );
  };
}

MultiSectionsModal.propTypes = {
  children: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  bodyClasses: PropTypes.string,
  disableNavigation: PropTypes.bool,
  revealErrors: PropTypes.func,
};

export default MultiSectionsModal;



// WEBPACK FOOTER //
// ./src/components/common/Modals/MultiSectionsModal.js